import type { Market } from '../types/content';

export const MARKET_EVENT = 'win21der:market';

export const marketHash: Record<Market, string> = {
  commercial: '#commercial-painting',
  residential: '#residential-painting',
};

/** Ask the services section to switch to a market tab (works even if the URL hash is unchanged). */
export function requestMarket(market: Market) {
  window.dispatchEvent(new CustomEvent<Market>(MARKET_EVENT, { detail: market }));
}

export function marketFromHash(hash: string): Market | null {
  if (hash === marketHash.commercial) return 'commercial';
  if (hash === marketHash.residential) return 'residential';
  return null;
}
